
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Observable  } from 'rxjs';
import {  finalize, shareReplay, takeUntil } from 'rxjs/operators';

import { BaseSelectionListProperties } from './base-selection-list-properties.component';


@Component({
    selector: 'app-base-form',
    template: ``,
    standalone: false
})

export abstract class BaseSelectionList extends BaseSelectionListProperties implements OnInit {

  constructor() { super(); }

  abstract initConfig();
  abstract getItems();

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["id"] && this.id)
      this.getItems();

  }

  emitValues(event) {
    this.output_values.emit(event);
  }

  emitClickedOption(event){
    this.output_clickedOption.emit(event);
  }

  emitItems(event) {
    this.output_items.emit(event);
  }

  unSubs(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  baseSelectionSearchPipeOperators = (source$: Observable<any>): Observable<any> => {
    return source$.pipe(
      shareReplay(),
      takeUntil(this.onDestroy$),
      finalize(() => {
        this.loading = false;
      })
    )
  }

  ngOnDestroy(): void {
    this.unSubs();
  }



}
